module.exports = __webpack_public_path__ + "img/xzjx.782d3d00.png";